import React from "react";
import useScrollReveal from "@/hooks/useScrollReveal";

import CategoryHero from "@/components/site/CategoryHero";
import CategoryTabs from "@/components/site/CategoryTabs";
import ProcessMain from "@/components/site/main/ProcessMain";
import ProjectCatalogue from "@/components/site/ProjectCatalogue";
import WhatWeOfferMain from "@/components/site/main/WhatWeOfferMain";
import TrustedPartners from "@/components/site/TrustedPartners";
import LaunchOfferMain from "@/components/site/main/LaunchOfferMain";
import FAQ, { MAIN_FAQS } from "@/components/site/FAQ";
import PreFooterCTAMain from "@/components/site/main/PreFooterCTAMain";
import SEO from "@/components/site/SEO";
import { pageSeo, localBusinessJsonLd, serviceJsonLd, faqJsonLd } from "@/lib/seo-config";

export default function RetailBrandingDubai() {
    useScrollReveal();
    return (
        <main data-testid="page-retail-branding">
            <SEO
                {...pageSeo.retail}
                jsonLd={[
                    localBusinessJsonLd,
                    serviceJsonLd({
                        type: "Retail Branding",
                        name: "Retail Branding Dubai",
                        description: pageSeo.retail.description,
                        path: pageSeo.retail.path,
                    }),
                    faqJsonLd(MAIN_FAQS),
                ]}
            />
            <CategoryHero
                eyebrow="RETAIL BRANDING • DUBAI"
                h1="Retail Branding & Store Fit-Out in Dubai"
                sub="Store interiors, storefronts, display zones, lighting, customer flow and launch-ready branding for Dubai retail brands — delivered with clarity, speed and premium finish."
                image="https://customer-assets.emergentagent.com/job_dream-design-deliver/artifacts/sc7pkfad_Retail.jpg"
                imageAlt="Premium Dubai retail store interior with display zones, storefront branding and mood lighting"
                estimatorType="retail"
            />
            <CategoryTabs initialTab="retail" />
            <ProcessMain />
            <ProjectCatalogue />
            <WhatWeOfferMain />
            <TrustedPartners />
            <LaunchOfferMain />
            <FAQ items={MAIN_FAQS} />
            <PreFooterCTAMain />
        </main>
    );
}
